"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferResponseSchema = exports.OfferDetailResultSchema = exports.OfferDetailSchema = exports.OfferSearchResponseSchema = exports.OfferSearchResultSchema = exports.OfferSearchItemSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const schemas_1 = require("../../../../schemas");
const offers_1 = require("../../../../schemas/offers");
exports.OfferSearchItemSchema = zod_1.default.discriminatedUnion('type', [offers_1.OfferLetterSchema, offers_1.OfferReminderSchema]);
exports.OfferSearchResultSchema = zod_1.default.object({ offers: exports.OfferSearchItemSchema.array() });
exports.OfferSearchResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OfferSearchResultSchema);
exports.OfferDetailSchema = exports.OfferSearchItemSchema;
exports.OfferDetailResultSchema = zod_1.default.object({ offer: exports.OfferDetailSchema });
exports.OfferResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.OfferDetailResultSchema);
